import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
//import { authGuard } from './shared/auth/auth.guard';

const routes: Routes = [
    { path: '', loadChildren: () => import('./features/layout/layout.module').then((m) => m.LayoutModule)/*, canActivate: [authGuard] */},
    { path: '**', loadChildren: () => import('./features/layout/layout.module').then((m) => m.LayoutModule)/*, canActivate: [authGuard] */},
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
